import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';

@Injectable()
export class ValidateService {
  constructor() { }

  public prohibitedSymbolsValidator(): ValidatorFn {
    return this.prohibitExpressionValidator(/[&\'<>]/, 'Please avoid using invalid tags');
  }

  public prohibitApostropheValidator(): ValidatorFn {
    return this.prohibitExpressionValidator(/[']/, 'Please avoid using an apostrophe');
  }

  public prohibitAmpersandValidator(): ValidatorFn {
    return this.prohibitExpressionValidator(/[&]/, 'Please avoid using an ampersand');
  }

  private prohibitExpressionValidator(expression: RegExp, message: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const isMatched = expression.test(control.value);
      return isMatched ? { prohibitedSymbols: message } : null;
    };
  }
}